// Static Currency list for the footer locale switcher (spec-029).
// Only entries here are ever selectable or visible — same omit-until-shipped
// rule as regions.ts (FR-011). A real second currency also needs the backend
// work mapped out in specs/029-footer-locale-switcher/spec.md's Currency
// Conversion Follow-On Scope section — this array alone isn't sufficient
// once conversion is real.

export interface Currency {
  /** ISO 4217 code, e.g. 'USD'. */
  code: string
  symbol: string
  /** i18n key (relative to the 'navigation' namespace — this array is only ever consumed via useTranslation('navigation')) for the display name (FR-014). */
  nameKey: string
}

export const CURRENCIES: Currency[] = [
  { code: 'USD', symbol: '$', nameKey: 'chrome.locale.currencies.usd' },
]
